import {SortingAndFilteringParams} from "../../helpers/api";
import http from "../../common/services/httpService";
import {Api, apiUrls} from "../../helpers/api";
import {NewUnCodeModel, UnCodeModel, UnCodeModelForDropdown} from "../models/unCode";
import {PageableModel} from "../../common/models/table";
import {AxiosResponse} from "axios";
import {HttpErrorModel} from "../../common/models/httpError";

export class UnCodeService {
    private static basicUrl = apiUrls.dictionaries.unCodes;

    public static async getAll(sortingAndFilteringParams?: SortingAndFilteringParams, name?: string, code?: string): Promise<AxiosResponse<PageableModel<UnCodeModel>>> {
        if (sortingAndFilteringParams) {
            const nameFilter = name && `name~:${name}`;
            const codeFilter = code && `code~:${code}`;
            sortingAndFilteringParams.filterCondition = `${nameFilter}${name && codeFilter && ","}${codeFilter}`;
        }

        const url = Api.addSortingAndFilteringParams(Api.getUrl(this.basicUrl), sortingAndFilteringParams);
        return await http.get<PageableModel<UnCodeModel>>(url);
    }

    public static async getUnCode(id: string): Promise<AxiosResponse<UnCodeModel>> {
        return await http.get(`${Api.getUrl(this.basicUrl)}/${id}`);
    }

    public static async modifyUnCode(data: NewUnCodeModel, id: string): Promise<AxiosResponse<HttpErrorModel[]|any>> {
        return await http.post(`${Api.getUrl(this.basicUrl)}/${id}`, data);
    }

    public static async removeUnCode(id: string): Promise<AxiosResponse> {
        return await http.delete(`${Api.getUrl(this.basicUrl)}/${id}`);
    }

    public static async getActiveUnCodes(): Promise<AxiosResponse<UnCodeModelForDropdown[]>> {
        return await http.get<UnCodeModelForDropdown[]>(`${Api.getUrl(this.basicUrl)}/dropdown`);
    }

    public static async addUnCode(data: NewUnCodeModel): Promise<AxiosResponse<HttpErrorModel[]|any>>  {
        return await http.post(Api.getUrl(this.basicUrl), data);
    }
}
